export default "__VITE_ASSET__c45c0c5a__"